"use client";

import { HeroSection } from "@/(landing-page)/sections/HeroSection";
import { ConceptSection } from "@/(landing-page)/sections/ConceptSection";
import { ParallaxSection } from "@/(landing-page)/sections/ParallaxSection";
import { EquipmentsSection } from "@/components/sections/EquipmentsSection";
import { PlaceSection } from "@/(landing-page)/sections/PlaceSection";
import { HorizonSection } from "@/(landing-page)/sections/HorizonSection";
import { OffersSection } from "@/components/sections/OffersSection";
// import { ReviewsSection } from "@/(landing-page)/sections/ReviewsSection";
import { ContactSection } from "@/(landing-page)/sections/ContactSection";
import { LocalSearchSection } from "@/(landing-page)/sections/LocalSearchSection";
import { Suspense } from "react";

export default function HomePage() {
  return (
    <main className="flex min-h-screen flex-col">
      <HeroSection />
      <PlaceSection />
      <ConceptSection />
      <ParallaxSection />
      <HorizonSection />
      <EquipmentsSection />
      <OffersSection />
      {/* <ReviewsSection /> */}
      <Suspense fallback={null}>
        <ContactSection />
      </Suspense>
      <LocalSearchSection />
    </main>
  );
}
